<template>
	<div class="a-timeline-hotels">
		<div class='a-timeline-item'>
			<div class='a-timeline-hotels-wrap'>
				<div class='a-timeline-hotels-image' v-if='!hideImage'>
					<img
						:src="item.image && item.image.length
          ? (item.image.indexOf('http') ? `https://tcc.ua${item.image}` : item.image)
          : require('@/assets/hotel/no-photo.webp')"
						@error="event => event.target.src = require('@/assets/hotel/no-photo.webp')"
					/>
				</div>
				<div class='a-timeline-hotels-content' :style='hideImage ? "margin-left: 0" : null'>
					<ul class='a-timeline-hotels-stars-list'>
						<li class='a-timeline-hotels-stars-item' v-for='(item, i) in item.categorySimpleCode' :key='i'>
							<v-icon icon='star' size='10' />
						</li>
					</ul>
					<p class='a-timeline-hotels-title'>{{item.name}}</p>
					<div class="a-timeline-hotels-info">
						<a class='a-text-with-icon app-link' style='font-weight: 400 !important' :href='item.place' target="_blank">
							<v-icon icon='pin' size='13' />
							<span>{{item.address ? `${item.address}, `: null}}{{item.postalCode}} {{item.countryName}}</span>
						</a>
					</div>

					<div class='a-timeline-hotels-dates mobile-show'>
						<div class='row'>
							<div class='col-auto'>
								<p class='a-timeline-hotels-descr'>{{$t('account.form.placeholder.dateFrom')}}</p>
								<p class='a-timeline-hotels-text' v-if='item.searchData'>{{$moment(item.searchData.dateFrom).format("ddd, DD MMM YYYY")}}</p>
							</div>
							<div class='col-auto'>
								<p class='a-timeline-hotels-descr'>{{$t('account.form.placeholder.dateTo')}}</p>
								<p class='a-timeline-hotels-text' v-if='item.searchData'>{{$moment(item.searchData.dateTo).format("ddd, DD MMM YYYY")}}</p>
							</div>
						</div>
					</div>

					<div class='row a-timeline-hotels-rooms'>
						<div class='col-auto'>
							<p class='a-timeline-hotels-rooms-text'>
								<v-icon icon='bed' size='13' />
								<span>{{item.roomName}}</span>
							</p>
							<p class='a-timeline-hotels-rooms-text'>
								<v-icon icon='tea' size='13' />
								<span>{{item.boardName}}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class='a-timeline-hotels-footer mobile-hide'>
				<div class='row'>
					<div class='col-auto'>
						<p class='a-timeline-hotels-descr'>{{$t('account.form.placeholder.dateFrom')}}</p>
						<p class='a-timeline-hotels-text' v-if='item.searchData'>{{$moment(item.searchData.dateFrom).format("ddd, DD MMM YYYY")}}</p>
					</div>
					<div class='col-auto'>
						<p class='a-timeline-hotels-descr'>{{$t('account.form.placeholder.dateTo')}}</p>
						<p class='a-timeline-hotels-text' v-if='item.searchData'>{{$moment(item.searchData.dateTo).format("ddd, DD MMM YYYY")}}</p>
					</div>
				</div>

				<div class='a-timeline-hotels-cancel'>
						<button type='button' class='a-timeline-hotels-cancel-button-link' :class='{"active": cancellationPolicies}' @click='cancellationPolicies = !cancellationPolicies'>
							<span>{{$t("account.result.terms_of_cancellation")}}</span>
							<v-icon icon='arrow-down' size='10' />
						</button>
						<template v-if='cancellationPolicies'>
							<p class='a-timeline-hotels-cancel-item' v-for="(cancel, i) in penalties" :key='i'>
								{{$t("account.result.after")}} {{$moment(cancel.from).format('DD.MM.YYYY')}} — <b>{{$helpers.amount(cancel.amount, item.price.total.currency)}}</b>
							</p>
						</template>
				</div>

			</div>
			<div class='a-timeline-flights-item-footer' v-if='!result'>
				<div class="a-timeline-flights-item-footer-details">
					<p class='app-link green--text' @click='card_details = true'>{{$t('account.buttons.read_more')}}</p>
				</div>
			</div>
		</div>
		<a-timeline-markup
			:item='item'
			:price='item.price'
			:title='title'
			:titleIcon='titleIcon'
			:result='result'
			@update-order='$emit("update-order", $event)'
		/>

		<trips-card-details v-model='card_details' :card='item' />

		<div class='a-timeline-item a-timeline-hotels-choose' v-if='item.selectedTransfer'>
			<div class='a-timeline-hotels-choose-item'>
				<p class='a-timeline-hotels-choose-title'>{{$t('account.details.hotels.transfer')}}</p>
				<p class='a-timeline-hotels-choose-text'>{{item.selectedTransfer.name}} •
					<strong>{{$helpers.amount(item.selectedTransfer.price.total.amount, item.selectedTransfer.price.total.currency)}}</strong>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import ATimelineMarkup from '@/views/account/itinerary/markup';
	import TripsCardDetails from '@/views/account/itinerary/timeline/hotels-details';

	export default {
		data: () => ({
			card_details: false,
			cancellationPolicies: false
		}),
		props: ['item', 'title', 'titleIcon', 'result', 'hideImage'],
		computed: {
			// Штрафы без нулевых (так часть поставщиков помечает конец бесплатного окна)
			// и без повторов суммы подряд — как в карточке отеля.
			penalties() {
				return (this.item.cancellationPolicies || [])
					.map(item => ({ from: item.from, amount: Number(item.amount) }))
					.filter(item => item.amount > 0)
					.filter((item, i, all) => i === 0 || item.amount !== all[i - 1].amount);
			}
		},
		components: {
			ATimelineMarkup,
			TripsCardDetails
		}
	}
</script>

<style lang="scss">
	@import "@/styles/global/variables";
	@import "@/styles/global/mixins";

	.a-timeline-hotels {
		&-wrap {
			@include minw($grid-breakpoints-xs) {
				padding: 20px * .8;
				display: flex;
				align-items: stretch;
			}
			@include minw($grid-breakpoints-lg) {
				padding: 20px;
			}
		}
		&-image {
			flex-shrink: 0;
			width: 100%;
			height: 170px;
			border-radius: 5px 5px 0 0;
			overflow: hidden;
			@include minw($grid-breakpoints-xs) {
				width: 225px;
				height: 140px;
				border-radius: 5px;
			}
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
		&-content {
			padding: 15px;
			margin: 0;
			flex: 1 1 100%;
			@include minw($grid-breakpoints-xs) {
				padding: 0;
				margin: 5px * .8 0 0 25px * .8;
			}
			@include minw($grid-breakpoints-lg) {
				margin: 5px 0 0 25px;
			}
		}
		&-stars {
			&-list {
				display: flex;
				margin-bottom: 10px * .8;
				@include minw($grid-breakpoints-lg) {
					margin-bottom: 10px;
				}
			}
			&-item {
				margin: 0 1px;
				color: $yellow;
			}
		}
		&-title {
			font-size: 22px * .8;
			line-height: 23px * .8;
			font-weight: 700;
			margin-bottom: 15px * .8;
			@include minw($grid-breakpoints-md) {
				font-size: 22px * .9;
				line-height: 23px * .9;
			}
			@include minw($grid-breakpoints-lg) {
				font-size: 22px;
				line-height: 23px;
				margin-bottom: 15px;
			}
		}
		&-dates {
			margin: 20px 0;
		}
		&-rooms {
			flex-direction: column;
			@include minw($grid-breakpoints-xs) {
				margin-top: 25px;
				flex-direction: row;
				align-items: flex-end;
			}
			&-text {
				display: flex;
				align-items: center;
				font-size: 13px;
				font-weight: 400;
				margin-bottom: 5px;
				.app-icon {
					flex-shrink: 0;
					margin-right: 8px;
				}
			}
			&-group {
				display: flex;
				align-items: center;
				color: $green-persian;
				.app-icon {
					margin-right: 10px;
					margin-bottom: 5px;
				}
			}
		}
		&-footer {
			@include minw($grid-breakpoints-xs) {
				padding: 0 20px * .8 25px * .8;
			}
			@include minw($grid-breakpoints-lg) {
				padding: 0 20px 25px;
			}
		}
		&-descr {
			font-size: 10px;
			font-weight: 400;
			line-height: 1.5;
			color: rgba($black, .6);
		}
		&-text {
			font-size: 12px;
			font-weight: 400;
			line-height: 1.5;
			text-transform: capitalize;
		}
		&-choose {
			margin-top: 30px;
			@include minw($grid-breakpoints-xs) {
				margin-top: 50px;
			}
			&-item {
				padding: 20px 15px;
				@include minw($grid-breakpoints-xs) {
					padding: 25px;
				}
			}
			&-title {
				font-size: 18px;
				font-weight: 700;
				margin-bottom: 12px;
			}
			&-text {
				font-size: 16px;
				font-weight: 400;
				&:not(:last-child) {
					margin-bottom: 5px;
				}
			}
			&-descr {
				font-size: 12px;
				font-weight: 400;
				color: rgba($black, .5);
				margin-top: 25px;
			}
		}
		&-cancel {
			margin-top: 12px;
			p {
				text-transform: none;
			}
			// Как «Условия отмены» в строках тарифов на странице отеля.
			&-button-link {
				display: inline-flex;
				align-items: center;
				padding: 0;
				border: none;
				background: none;
				font-size: 13px;
				font-weight: 400;
				color: $orange;
				cursor: pointer;
				transition: opacity $transition;
				span {
					border-bottom: 1px dashed currentColor;
				}
				.app-icon {
					margin-left: 6px;
					transition: transform $transition;
				}
				&:hover {
					opacity: .75;
				}
				&.active .app-icon {
					transform: rotate(180deg);
				}
			}
			&-item {
				margin-top: 5px;
				font-size: 13px;
				font-weight: 400;
				color: $black;
			}
		}
	}
</style>
